import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

import algorandIcon from "assets/images/crypto/icons/AlgorandIcon.png";
import bitcoinIcon from "assets/images/crypto/icons/BitcoinIcon.png";
import dogecoinIcon from "assets/images/crypto/icons/DogecoinIcon.png";
import ethereumIcon from "assets/images/crypto/icons/EthereumIcon.png";
import litecoinIcon from "assets/images/crypto/icons/LitecoinIcon.svg";
import moneroIcon from "assets/images/crypto/icons/MoneroIcon.png";
import ravencoinIcon from "assets/images/crypto/icons/RavencoinIcon.png";
import rippleIcon from "assets/images/crypto/icons/RippleIcon.png";
import zcashIcon from "assets/images/crypto/icons/ZCashIcon.svg";

import algorandQR from "assets/images/crypto/qrcodes/Algorand QR.png";
import bitcoinQR from "assets/images/crypto/qrcodes/Bitcoin QR.png";
import dogecoinQR from "assets/images/crypto/qrcodes/Dogecoin QR.png";
import ethereumQR from "assets/images/crypto/qrcodes/Ethereum QR.png";
import litecoinQR from "assets/images/crypto/qrcodes/Litecoin QR.png";
import moneroQR from "assets/images/crypto/qrcodes/Monero QR.png";
import ravencoinQR from "assets/images/crypto/qrcodes/Ravencoin QR.png";
import rippleQR from "assets/images/crypto/qrcodes/Ripple QR.png";
import zcashQR from "assets/images/crypto/qrcodes/ZCash QR.png";
import SupportTile from "shared/SupportTile";

const cryptOptions = [
  {
    name: "Bitcoin",
    symbol: "BTC",
    address: "bc1qnye00fpwy7ada346wpek60nx2fufhhffj4xs8e",
    icon: bitcoinIcon,
    qrCode: bitcoinQR,
  },
  {
    name: "Ethereum",
    symbol: "ETH",
    address: "0xF6D9A39A174902AFD9c1dE6Cd88117c0dfc687Be",
    icon: ethereumIcon,
    qrCode: ethereumQR,
  },
  {
    name: "Litecoin",
    symbol: "LTC",
    address: "ltc1qc07zmx34pgc647qnreywhcxre6f58cr6z6zkzd",
    icon: litecoinIcon,
    qrCode: litecoinQR,
  },
  {
    name: "Dogecoin",
    symbol: "DOGE",
    address: "DAaVMxMFJ8MBbLpRTYr1bvXF46DdsJnSVV",
    icon: dogecoinIcon,
    qrCode: dogecoinQR,
  },
  {
    name: "Monero",
    symbol: "XMR",
    address:
      "44aFzmo8XqETdXSwGz8fad16WzcG4S6YSLCWfSCWQxKbRhGGDoAmSTB6jLH4oWQTJy8T4Z2i48UUa8vmLRsS69pvBYLFW7E",
    icon: moneroIcon,
    qrCode: moneroQR,
  },
  {
    name: "Ripple",
    symbol: "XRP",
    address: "rKK7usD9jb7AppY23iyq2Lqh4UyfiFSorH",
    icon: rippleIcon,
    qrCode: rippleQR,
  },
  {
    name: "Zcash",
    symbol: "ZEC",
    address: "t1MG97Vvzi6QtqMKdaWJ1apXTbCSyz3w8mc",
    icon: zcashIcon,
    qrCode: zcashQR,
  },
  {
    name: "Algorand",
    symbol: "ALGO",
    address: "T35GYQUCWL7KX3K2HDMMKH7V5HWPYFR5ZC5J2KZEFDQJR3AMSQ2BEDX7ZE",
    icon: algorandIcon,
    qrCode: algorandQR,
  },
  {
    name: "RavenCoin",
    symbol: "RVN",
    address: "RGuSSkyeXvs8UBtGkUm8DuyXcvkNpBSyBf",
    icon: ravencoinIcon,
    qrCode: ravencoinQR,
  },
];


const Crypto = ({ ...props }) => {
const iconWidth = "300px";

  return (
    <Grid container xs={12} spacing={2} rowGap={10} columnGap={2} m={2}>
      {cryptOptions
        // .filter((test, index)=> index ===0)
        .map((option) => (
          <Box
            key={option.address}
            sx={{ width: iconWidth, height: iconWidth }}
          >
            <SupportTile
              icon={option.icon}
              qrCode={option.qrCode}
              name={option.name}
              address={option.address}
              width={iconWidth}
              height={iconWidth}
            />
          </Box>
        ))}
    </Grid>
  );
};

export default Crypto;
